import { render } from "./redeem.vue?vue&type=template&id=4428a0b2&scoped=true"
import script from "./redeem.vue?vue&type=script&lang=js"
export * from "./redeem.vue?vue&type=script&lang=js"

import "./redeem.vue?vue&type=style&index=0&id=4428a0b2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4428a0b2"]])

export default __exports__